<template>
  <div class="mainfont page-container">
    <v-snackbar v-model="showSnackBar" color="black">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#13736f"
      spinner="spinner"
    />

    <PageHeader :title="config.title" :subtitle="config.subtitle" icon="mdi-pine-tree" :count="totalData">
      <template v-slot:actions>
        <v-btn v-if="config.canAdd" depressed class="btn-act btn-act--primary" to="/addcamp">
          <v-icon left>mdi-plus</v-icon>
          Add nature camp
        </v-btn>
      </template>
    </PageHeader>

    <section class="surface mb-5">
      <div class="filter-bar">
        <div v-if="config.search" class="filter-bar-search">
          <v-text-field
            v-model="keyword"
            clearable
            dense
            outlined
            hide-details
            placeholder="Search camps"
            background-color="white"
            color="#13736f"
            prepend-inner-icon="mdi-magnify"
            @input="onSearchInput"
            @click:clear="onSearchClear"
          ></v-text-field>
        </div>
        <template v-if="config.officeFilters">
          <div>
            <v-autocomplete
              v-model="circleid"
              :items="circle"
              item-text="officeName"
              item-value="_id"
              clearable
              dense
              outlined
              hide-details
              placeholder="All circles"
              background-color="white"
              color="#13736f"
              prepend-inner-icon="mdi-map-outline"
            ></v-autocomplete>
          </div>
          <div>
            <v-autocomplete
              v-model="divisionid"
              :items="division"
              item-text="officeName"
              item-value="_id"
              clearable
              dense
              outlined
              hide-details
              :disabled="!circleid"
              :placeholder="circleid ? 'All divisions' : 'Pick a circle first'"
              background-color="white"
              color="#13736f"
              prepend-inner-icon="mdi-domain"
            ></v-autocomplete>
          </div>
        </template>
        <div>
          <v-autocomplete
            v-model="rangeid"
            :items="range"
            item-text="officeName"
            item-value="_id"
            clearable
            dense
            outlined
            hide-details
            :disabled="config.officeFilters && !divisionid"
            :placeholder="config.officeFilters && !divisionid ? 'Pick a division first' : 'All ranges'"
            background-color="white"
            color="#13736f"
            prepend-inner-icon="mdi-map-marker-path"
          ></v-autocomplete>
        </div>
      </div>
    </section>

    <!-- Camp cards -->
    <div v-if="list.length" class="camp-grid">
      <article v-for="item in list" :key="item._id" class="camp-card">
        <div class="camp-cover">
          <safe-image :src="item.image ? (mediaURL + item.image) : ''" :fallback="require('../../assets/Images/ibimage12.jpg')" alt="" />
          <span
            v-if="item.campType"
            class="camp-type camp-cover-tag"
            :class="item.campType === 'free' ? 'camp-type--free' : 'camp-type--paid'"
          >
            {{ item.campType === "free" ? "Free camp" : "Paid camp" }}
          </span>
        </div>
        <div class="camp-body">
          <h3 class="camp-name">{{ item.campName }}</h3>
          <div v-if="item.propertyName" class="camp-line">
            <v-icon x-small color="#94a3b8">mdi-home-outline</v-icon>
            {{ item.propertyName }}
          </div>
          <div v-if="officePath(item)" class="camp-line">
            <v-icon x-small color="#94a3b8">mdi-map-marker-outline</v-icon>
            {{ officePath(item) }}
          </div>
          <div class="camp-meta">
            <span v-if="item.district" class="member-count">
              <v-icon x-small color="#475569">mdi-map-outline</v-icon>
              {{ item.district }}
            </span>
            <span v-if="item.totalMembers" class="member-count">
              <v-icon x-small color="#475569">mdi-account-group-outline</v-icon>
              {{ item.totalMembers }} max
            </span>
          </div>
        </div>
        <div class="camp-actions">
          <v-btn
            v-for="action in config.actions"
            :key="action.key"
            depressed
            class="btn-act btn-act--sm"
            :class="'btn-act--' + action.tone"
            @click="runAction(action, item)"
          >
            <v-icon small left>{{ action.icon }}</v-icon>
            {{ action.label }}
          </v-btn>
        </div>
      </article>
    </div>

    <div v-else-if="!appLoading" class="surface empty-state">
      <v-icon size="48">mdi-pine-tree</v-icon>
      <div class="font-weight-bold" style="color: #334155">No nature camps found</div>
      <div style="font-size: 13px">Try a different search or filter.</div>
    </div>

    <div v-if="pages > 1" class="pagination-bar mt-4" style="border-top: none">
      <v-pagination
        v-model="currentPage"
        :length="pages"
        :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
        prev-icon="mdi-chevron-left"
        next-icon="mdi-chevron-right"
        color="#13736f"
      ></v-pagination>
    </div>

    <!-- Delete confirmation -->
    <v-dialog v-model="deletedialog" persistent max-width="450px">
      <v-card>
        <div class="dialog-head dialog-head--danger">
          <div>
            <div class="dialog-head-title">Delete nature camp?</div>
            <div class="dialog-head-subtitle">This can't be undone.</div>
          </div>
        </div>
        <v-card-text class="pt-5">Are you sure you want to delete this camp?</v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-spacer></v-spacer>
          <v-btn depressed class="btn-act btn-act--neutral" @click="deletedialog = false">Keep it</v-btn>
          <v-btn depressed class="btn-act btn-act--danger-solid px-5" @click="deleteItem">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageHeader from "@/components/Common/PageHeader";
import SafeImage from "@/components/Common/SafeImage";
import { getUserType } from "@/components/Common/navConfig";

const EDIT = { key: "edit", label: "Edit", icon: "mdi-pencil-outline", tone: "primary", to: "/editib" };

const ROLES = {
  admin: {
    title: "Manage Nature Camps",
    subtitle: "All nature camps across circles and divisions.",
    listUrl: "/all/naturecamp",
    canAdd: true,
    search: true,
    officeFilters: true,
    actions: [EDIT, { key: "delete", label: "Delete", icon: "mdi-delete-outline", tone: "danger" }],
  },
  division: {
    title: "Nature Camps",
    subtitle: "Your division's camps. Block dates or update camp details.",
    listUrl: "/division/naturecamp",
    canAdd: false,
    search: false,
    officeFilters: false,
    actions: [
      EDIT,
      { key: "block", label: "Block dates", icon: "mdi-calendar-remove-outline", tone: "warning", to: "/blockdate" },
      { key: "blocked", label: "Blocked dates", icon: "mdi-calendar-search", tone: "info", to: "/ViewReservations" },
    ],
  },
  clerk: {
    title: "Nature Camps",
    subtitle: "Nature camps operating under your division.",
    listUrl: "/division/naturecamp",
    canAdd: false,
    search: true,
    officeFilters: false,
    actions: [
      { key: "view", label: "View Details", icon: "mdi-eye-outline", tone: "primary", to: "/NatureCampDetails" },
    ],
  },
};

export default {
  name: "CampManagement",
  components: {
    PageHeader,
    SafeImage,
  },
  data() {
    return {
      appLoading: false,
      msg: null,
      showSnackBar: false,
      list: [],
      totalData: 0,
      pages: 0,
      currentPage: 1,
      keyword: "",
      searchTimer: null,
      circle: [],
      division: [],
      range: [],
      circleid: null,
      divisionid: null,
      rangeid: null,
      deletedialog: false,
      curid: null,
    };
  },
  computed: {
    role() {
      return getUserType();
    },
    config() {
      return ROLES[this.role] || ROLES.division;
    },
  },
  watch: {
    circleid(newVal) {
      if (!newVal) {
        this.divisionid = null;
        this.rangeid = null;
      }
      this.getDivision();
      this.reload();
    },
    divisionid(newVal) {
      if (!newVal) this.rangeid = null;
      if (this.config.officeFilters) this.getRange();
      this.reload();
    },
    rangeid() {
      this.reload();
    },
    currentPage() {
      this.getList();
    },
  },
  mounted() {
    if (this.config.officeFilters) {
      this.getCircle();
    } else {
      this.getRange();
    }
    this.getList();
  },
  methods: {
    notify(message) {
      this.msg = message;
      this.showSnackBar = true;
    },
    officePath(item) {
      return [item.circleid, item.divisionid, item.rangeid]
        .map((o) => (o && o.officeName) || "")
        .filter(Boolean)
        .join(" · ");
    },
    reload() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getList();
      }
    },
    onSearchInput() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.reload(), 400);
    },
    onSearchClear() {
      this.keyword = "";
      this.reload();
    },
    runAction(action, item) {
      if (action.key === "delete") {
        this.curid = item._id;
        this.deletedialog = true;
      } else {
        this.$router.push(action.to + "?id=" + item._id);
      }
    },
    getList() {
      this.appLoading = true;
      const data = {
        rangeid: this.rangeid,
        circleid: this.circleid,
        divisionid: this.divisionid,
        page: this.currentPage,
        limit: 15,
      };
      if (this.config.search) data.keyword = this.keyword;
      axios({
        method: "POST",
        url: this.config.listUrl,
        headers: { token: localStorage.getItem("token") },
        data,
      })
        .then((response) => {
          this.list = response.data.data || [];
          this.totalData = response.data.totalLength || 0;
          this.pages = Math.ceil(this.totalData / (response.data.limit || 15)) || 0;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.notify("Couldn't load nature camps. Please try again.");
          console.log(err);
        });
    },
    getCircle() {
      axios({
        method: "GET",
        url: "/get/circles",
        headers: { token: localStorage.getItem("token") },
      })
        .then((response) => {
          this.circle = response.data.data || [];
        })
        .catch((err) => console.log(err));
    },
    getDivision() {
      const selectedCircle = this.circle.find((c) => c._id === this.circleid);
      if (!selectedCircle) {
        this.division = [];
        return;
      }
      axios({
        method: "post",
        url: "/get/divsions",
        headers: { token: localStorage.getItem("token") },
        data: { path: selectedCircle.path },
      })
        .then((response) => {
          this.division = response.data.data || [];
        })
        .catch((err) => console.log(err));
    },
    getRange() {
      if (this.config.officeFilters) {
        // Admin: ranges of the chosen division
        const selectedDivision = this.division.find((d) => d._id === this.divisionid);
        if (!selectedDivision) {
          this.range = [];
          return;
        }
        axios({
          method: "post",
          url: "/get/range",
          headers: { token: localStorage.getItem("token") },
          data: { divisionid: this.divisionid, path: selectedDivision.path },
        })
          .then((response) => {
            this.range = response.data.data || [];
          })
          .catch((err) => console.log(err));
      } else {
        // Division: its own ranges
        axios({
          method: "POST",
          url: "/get/range/v1",
          headers: { token: localStorage.getItem("token") },
          data: { rangeid: this.rangeid },
        })
          .then((response) => {
            this.range = response.data.data || [];
          })
          .catch((err) => console.log(err));
      }
    },
    deleteItem() {
      axios({
        url: "/delete/naturecamp",
        method: "POST",
        headers: { token: localStorage.getItem("token") },
        data: { campid: this.curid },
      })
        .then((response) => {
          this.notify(response.data.msg);
          this.deletedialog = false;
          if (response.data.status == true) this.getList();
        })
        .catch((err) => {
          this.notify("Couldn't delete the camp. Please try again.");
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.camp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.camp-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e6edf0;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.camp-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.1);
}

.camp-cover {
  position: relative;
  height: 150px;
  background: #e7f1f0;
}

.camp-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.camp-cover-tag {
  position: absolute;
  top: 12px;
  left: 12px;
  margin-top: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.camp-body {
  flex: 1;
  padding: 16px 16px 8px;
}

.camp-name {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.3;
  color: #0f172a;
  text-transform: capitalize;
}

.camp-line {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 2px;
  font-size: 13px;
  color: #64748b;
}

.camp-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.camp-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 8px;
  padding: 12px 16px 16px;
}

@media (max-width: 600px) {
  .camp-grid {
    gap: 14px;
  }

  .camp-cover {
    height: 130px;
  }
}
</style>
